export const FLIGHTS_ENDPOINTS = {
  home: "/api/Flight/GetHome",
  search: "/api/Flight/Search",
  routes: "/api/Flight/GetRoutes",
  offers: "/api/Flight/GetOffers",
};
